import React from 'react';

import FailedSeriesRecordingWhite from 'assets/images/svgs/Recording/ico_failed_series_recording.svg';
import FailedSeriesRecordingBlack from 'assets/images/svgs/Recording/ico_failed_series_recording_black.svg';

type Props = { highlighted: boolean; size: number };

function FailedSeriesRecording({ highlighted, size }: Props) {
    return highlighted ? (
        <FailedSeriesRecordingBlack width={size} height={size} />
    ) : (
        <FailedSeriesRecordingWhite width={size} height={size} />
    );
}

export default FailedSeriesRecording;
